// src/components/auth/ProtectedRoute.jsx
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export default function ProtectedRoute({ children, requireAdmin = false, requirePro = false }) {
  const { user, loading, isAdmin, isDemo, isPro, hasAccess, isTrialExpired, profile } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Demo users bypass all gates — they have full read-only access
  if (isDemo) return children;

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requirePro && !isPro && !isAdmin) {
    return <Navigate to="/subscribe" replace />;
  }

  const allowedWhenExpired = ['/subscribe', '/settings', '/support'];
  if (isTrialExpired && !isAdmin && !allowedWhenExpired.includes(location.pathname)) {
    return <Navigate to="/subscribe" state={{ expired: true }} replace />;
  }

  return children;
}
